import styled from 'styled-components';

export default styled.div `
  .ant-upload-list-item-container > div {
    height: 100%;
  }
`;
